/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-log-significance';
const prefix = `${moduleName}.${componentName}`;

export const significanceLabel = `${prefix}.significanceLabel`;

export const ENGLISH = {
    [significanceLabel]: 'Significance',
};
